import styled from "styled-components";

const Main = styled.div`
  margin: 10px 0 35px 0;
`;

export default Main;
